// ABOUTME: Hands a shared link — a workout or a plan — to the calendar page that can open it here.
// ABOUTME: A link carries the sender's page — a coach's home is the athletes list, an athlete has no /trainings.

import type { ReactNode } from "react"
import { Navigate, useLocation } from "react-router"
import { parsePlanUrl } from "../../utils/planUrl"
import { parseWorkoutUrl } from "../../utils/workoutUrl"

interface IProps {
  /** Where this user's calendar lives. */
  to: string
  /** What the page shows when the URL names nothing to open. */
  children?: ReactNode
}

export const SharedLinkHandoff = ({ to, children = null }: IProps) => {
  const { search } = useLocation()

  // A plan's window is opened by the calendar page too, and the address a sender copies carries
  // whichever page they were on — a coach's home among them, where nothing opens anything.
  if (parseWorkoutUrl(search) || parsePlanUrl(search))
    return (
      <Navigate
        to={{ pathname: to, search }}
        replace
      />
    )

  return <>{children}</>
}
